import type { ChatRoomListResponsePageAllOf } from './chatRoomListResponsePageAllOf';
import type { ChatRoomListResponsePageAllOfThree } from './chatRoomListResponsePageAllOfThree';

export type ChatRoomListResponsePage = ChatRoomListResponsePageAllOf & ChatRoomListResponsePageAllOfThree;
